import { createContext, useContext, useState, useCallback } from "react";

const WishlistContext = createContext();

export function WishlistProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ll_wishlist") || "[]");
    } catch { return []; }
  });

  const toggleItem = useCallback((product) => {
    setItems((prev) => {
      const exists = prev.find((i) => i.id === product.id);
      const next = exists
        ? prev.filter((i) => i.id !== product.id)
        : [...prev, product];
      localStorage.setItem("ll_wishlist", JSON.stringify(next));
      return next;
    });
  }, []);

  const isInWishlist = useCallback(
    (productId) => items.some((i) => i.id === productId),
    [items]
  );

  const clearWishlist = useCallback(() => {
    setItems([]);
    localStorage.setItem("ll_wishlist", "[]");
  }, []);

  return (
    <WishlistContext.Provider value={{ items, toggleItem, isInWishlist, clearWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
